import './eventfactory/style';
import FormStructure from './eventfactory/form_structure';

export default FormStructure;